import ExcutePanel from "./Index.vue";
let excutePanel = () => {};
export default {
  install: function (Vue) {
    const Instance = Vue.extend(ExcutePanel);
    let currentPanel = null;
    const initInstance = () => {
      if (!currentPanel) currentPanel = new Instance();
      let dom = currentPanel.$mount().$el;
      document.body.appendChild(dom);
    };
    Vue.prototype.$excutePanel = (options) => {
      initInstance();
      Object.assign(currentPanel, options);
      currentPanel.visible = true;
      return currentPanel;
    };
    excutePanel = Vue.prototype.$excutePanel;
  },
};
export { excutePanel };
